<template>
  <el-tree
    ref="tree"
    v-bind="$attrs"
    :render-content="renderContent"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'CustomTree',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  methods: {
    renderContent(h, { node, data, store }) {
      let iconClass = ''
      if (data.relationType === 'PROJECT') {
        iconClass = 'project-o'
      } else if (data.relationType === 'COMPANY') {
        iconClass = 'qiyegongchangjianzhu2'
      } else if (data.relationType === 'TEAM') {
        iconClass = 'banzu-'
      } else {
        iconClass = 'renyuan'
      }
      return (
        <span class='contentSpan'>
          <svgIcon icon-class={iconClass} />
          <span class='sourceName' title={data.sourceName}>
            { data.sourceName }
          </span>
        </span>
      )
    },
    getInstance() {
      return this.$refs.tree
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .contentSpan{
    font-size: 14px;
    display: flex;
    width: 100%;
    align-items: center;

    .sourceName{
      width: 0;
      flex: 1;
      padding-left: 4px;
       word-wrap: break-word; /*强制换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;/*隐藏后添加省略号*/
        white-space: nowrap;
        // padding-left: 4px;
        // font-size: 14px;

    }
}

// width: 100%;
//     display: flex;
//     align-items: center;
//     .label{
//         font-size: 14px;
//         flex: 1;
//         padding-left: 6px;
//         word-wrap: break-word; /*强制换行*/
//         overflow: hidden; /*超出隐藏*/
//         text-overflow: ellipsis;/*隐藏后添加省略号*/
//         white-space: nowrap;
//         box-sizing: border-box;
//         margin-right: 10px;

//     }
</style>
